<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['data', 'title', 'color'],
  computed: {
  	labels(){
  		return this.data.map(x => x.date).reverse();
  	},
  	entries(){
  		return this.data.map(x => x.count).reverse();	
  	}
  },
  mounted () {
    this.renderChart({
    	labels: this.labels,
    	datasets: [
        	{
          		backgroundColor: this.color,
          		data: this.entries
        	}
      	]
    },
    {
    	title: {
        	display: true,
        	text: this.title
    	},
    	legend: {
    		display: false
    	}
	});
  }
}	
</script>
